import React, { Fragment, useCallback, useState } from "react";
import PageTitle from "../../components/Ui/PageTitle";
import { Button, Card } from "react-bootstrap";
import { useSelector } from "react-redux";
import { isLoggedIn } from "../../store/selectors/UserSelectors";
import { config } from "../../config";
import ConfirmationModal from "../../components/Feedback/Modal/ConfirmationModal";
import ArchiveOrderDetails from "../Order/OrderDetails/ArchiveOrderDetails";
import { useHistory } from "react-router";
import { paths } from "../../router";
import CreateOrderButton from "../../components/CreateOrderButton";
import { OrderCategory, TApiOrderDetails } from "../../api/endpoints/Order";

const ArchiveOrderNew = () => {
  const history = useHistory();
  const userLoggedIn = useSelector(isLoggedIn);
  const [showLoginPopup, setShowLoginPopup] = useState<boolean>(false);

  const onLoginClick = useCallback(() => {
    window.location.href = config.loginUrl;
  }, []);

  const onOrderSaved = (order: TApiOrderDetails) => {
    history.push(paths.order(order.id));
  }

  const onNotLoggedInSave = () => {
    setShowLoginPopup(true);
  }

  return (
    <Fragment>
      <PageTitle title="Archive order" />

      <Card className="margin-bottom-sm">
        <Card.Body>
          <ArchiveOrderDetails />
        </Card.Body>
      </Card>

      {
        userLoggedIn ?
          <CreateOrderButton
            onSuccess={onOrderSaved}
            orderProps={
              {
                category: OrderCategory.ARCHIVE,
                folder_id: null
              }
            } />
          : <Button onClick={onNotLoggedInSave}>Create order</Button>
      }

      <ConfirmationModal
        show={showLoginPopup}
        onClose={() => setShowLoginPopup(false)}
        actions={
          <Fragment>
            <Button variant="secondary" onClick={() => setShowLoginPopup(false)}>Cancel</Button>
            <Button variant="primary" onClick={onLoginClick}>Log in</Button>
          </Fragment>
        }
      />
    </Fragment>
  )
}

export default ArchiveOrderNew;
